// extracted by mini-css-extract-plugin
module.exports = {"externalStickyHeader":"ExternalStickyHeader__externalStickyHeader__rbxPx","light":"ExternalStickyHeader__light__V4gZH","withBorder":"ExternalStickyHeader__withBorder__l2RPh"};